import api from '@/services/api';
const ENTITY_ENDPOINT = 'concepto';

export class ConceptoService {
  /**
   * Obtiene todos los conceptos con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los conceptos con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca conceptos por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un concepto por su ID
   * @param {string|number} id - ID del concepto
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo concepto
   * @param {Object} concepto - Datos del concepto a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(concepto) {
    return await api.post(`/${ENTITY_ENDPOINT}`, concepto);
  }

  /**
   * Actualiza un concepto existente
   * @param {string|number} id - ID del concepto
   * @param {Object} concepto - Datos del concepto a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, concepto) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, concepto);
  }

  /**
   * Elimina un concepto
   * @param {string|number} id - ID del concepto
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default ConceptoService;
